import consumer from './consumer'
import { notifyUserToReload } from '@/router/chunk-load-error-handler'
import router from '@/router'

export const subscribeToAfterDeployNoticesChannel = _ => {
  consumer.subscriptions.create('AfterDeployNoticesChannel', {
    received () {
      notifyUserToReload(router)
    },
  })
}
